<script>
	const pubsub = require('events/pubsub');
	const utilities = require('utilities');
	const stripHTMLFromString = utilities.stripHTMLFromString;

	const analyticsUtilities = require('utilities/analyticsUtilities');
	const fireEvent = analyticsUtilities.fireEvent;
	const TTS_PLAY = analyticsUtilities.events.TTS_PLAY;
	const TTS_PAUSE = analyticsUtilities.events.TTS_PAUSE;
	const TTS_COMPLETE = analyticsUtilities.events.TTS_COMPLETE;

	let voices = {};
	let currentlyPlayingUtterance = null;
	let cancelled = false;

	utilities.initTTSVoices().then(v => {
		voices = v;
	});

	module.exports = {
		props: {
			text: {
				required: true,
				type: String
			},
			language: {
				type: String,
				default: 'en'
			},
			eventData: {
				type: Object,
				default() {
					return {};
				}
			}
		},
		components: {
			'audio-player-icon': require('components/audio-player-icon.vue').default
		},
		data() {
			return {
				isPlaying: false,
				speechRate: 0.7,
				pitch: 1
			};
		},
		computed: {
			strippedText() {
				return stripHTMLFromString(this.text);
			}
		},
		methods: {
			onAudioClick() {
				const text = this.strippedText;
				const isPlaying = this.isPlaying;

				if (text) {
					if (speechSynthesis.speaking) {
						// speaking is true for actively playing and paused TTS
						if (isPlaying) {
							// Clicked this icon to pause
							this.pause();
						} else if (currentlyPlayingUtterance && text === currentlyPlayingUtterance.text) {
							// clicked this icon to resume
							this.resume();
						} else {
							// User clicked a different TTS icon
							this.stop();
							// Ensure queue is cleared before playing
							setTimeout(() => {
								cancelled = false;
								this.play();
							}, 50);
						}
					} else {
						this.play();
					}
				}
			},
			play() {
				const utterance = new SpeechSynthesisUtterance(this.strippedText);
				utterance.voice = voices[this.language] || voices.en;
				utterance.rate = this.speechRate;
				utterance.pitch = this.pitch;
				utterance.onend = this.onComplete;

				speechSynthesis.speak(utterance);
				this.isPlaying = true;
				currentlyPlayingUtterance = utterance;
				this.fireEvent(TTS_PLAY);
			},
			pause() {
				speechSynthesis.pause();
				this.isPlaying = false;
				this.fireEvent(TTS_PAUSE);
			},
			// Stops all TTS
			stop() {
				cancelled = true;
				speechSynthesis.cancel();
				this.isPlaying = false;
				currentlyPlayingUtterance = null;

				// Reset all TTS that aren't this one to isPlaying = false
				pubsub.publish('tts-stopped');
			},
			resume() {
				speechSynthesis.resume();
				this.isPlaying = true;
			},
			onComplete() {
				this.isPlaying = false;
				currentlyPlayingUtterance = null;

				if (!cancelled) {
					this.fireEvent(TTS_COMPLETE);
				}
			},
			fireEvent(name) {
				fireEvent(name, this.eventData);
			}
		},
		mounted() {
			this.$subscribe('tts-stopped', () => {
				if (!currentlyPlayingUtterance || this.strippedText !== currentlyPlayingUtterance.text) {
					this.isPlaying = false;
				}
			});
		},
		beforeDestroy() {
			if (currentlyPlayingUtterance && this.strippedText === currentlyPlayingUtterance.text) {
				speechSynthesis.cancel();
				currentlyPlayingUtterance = null;
			}
		}
	};
</script>
<style lang="scss"></style>
<template>
	<span class="text-to-speech-player-simple">
		<audio-player-icon
			:on-audio-click="onAudioClick"
			:is-playing="isPlaying">
		</audio-player-icon>
	</span>
</template>
